.empty {
  font-size: 0.85rem;
  font-style: italic;
  opacity: 0.6;
  padding: 4px 0 8px 0;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlBsYWNlSW5ncmVkaWVudHMuc2FzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFO0VBQ0E7RUFDQTtFQUNBIiwic291cmNlc0NvbnRlbnQiOlsiLmVtcHR5XG4gIGZvbnQtc2l6ZTogMC44NXJlbVxuICBmb250LXN0eWxlOiBpdGFsaWNcbiAgb3BhY2l0eTogMC42XG4gIHBhZGRpbmc6IDRweCAwIDhweCAwXG4iXX0= */